import lodash from 'lodash';
import { configure } from 'mobx';
import { BasesOptions } from './controller/';
import { AjaxBasics } from './helpers';
configure({ enforceActions: 'observed' });
AjaxBasics.defaultAjaxConfig.statusPath = ['status', 'code', 'errorCode'];
AjaxBasics.defaultAjaxConfig.responsePath = ['data'];
AjaxBasics.defaultAjaxConfig.messagePath = ['msg', 'message', 'errorMsg'];
AjaxBasics.defaultAjaxConfig.successStatus = [200, '200', '00000', 0];
export class ClientsEnv {
  /**
   * Node env
   * @memberof AppConfig
   */
  readonly NODE_ENV: typeof process.env.NODE_ENV = lodash.defaultTo<any>(
    process.env.NODE_ENV,
    'development',
  );
  /**
   * 环境
   * @memberof AppConfig
   */
  readonly APP_ENV: typeof process.env.APP_ENV = lodash.defaultTo<any>(
    process.env.APP_ENV,
    'develop',
  );
  /**
   * 获取 环境变量 可能是 ALL 模式
   * @param env
   * @returns
   */
  getProcess(env) {
    if (lodash.isObject(env)) {
      return lodash.get(env, this.APP_ENV);
    }
    return env;
  }
  /**
   *   share  分隔符 必须使用不会被编码的值
   * @memberof AppConfig
   */
  readonly shareSeparate = '_-_';

  /**
   * 微信公众号 Appid
   * @memberof AppConfig
   */
  readonly appid = this.getProcess(process.env.AppID);
  /**
   * 账号中台对应的 Appid
   * @memberof AppConfig
   */
  readonly appSourceId = this.getProcess(process.env.AppSourceId);
  /**
   * 账号中台对应的 isg Appid
   * @memberof isgAppConfig
   */
  readonly isgAppSourceId = this.getProcess(process.env.IsgAppSourceId);
  /**
   * 小程序原始ID
   * @memberof AppConfig
   */
  readonly appname = this.getProcess(process.env.AppName);
  /**
   * domain
   * @memberof AppConfig
   */
  readonly domain = this.getProcess(process.env.Domain);

  /**
   * api 地址
   * @memberof AppConfig
   */
  readonly target = this.getProcess(process.env.Target);
  /**
   * xiaozhi地址
   * @memberof AppConfig
   */
  readonly xiaozhi = this.getProcess(process.env.xiaozhi);
  /**
   * 网关 地址
   * @memberof AppConfig
   */
  readonly gateway = this.getProcess(process.env.Gateway);
  /**
   * IsgRedirectUrl isg 跳转地址
   * @memberof AppConfig
   */
  readonly isgredirectUrl = this.getProcess(process.env.IsgRedirectUrl);
  /**
   * 易分析 埋点ID
   * @memberof AppConfig
   */
  readonly lenovoWebsite = this.getProcess(process.env.LenovoWebsite);
  /**
   * 客服 地址
   * @memberof AppConfig
   */
  readonly customUrl = this.getProcess(process.env.CustomUrl);
  /**
   * lenovo id 地址
   * @memberof AppConfig
   */
  readonly lidDomain = this.getProcess(process.env.lidDomain);
  /**
   * 版本信息
   * @memberof AppConfig
   */
  readonly version = process.env.Version;
  /**
   * 构建时间戳
   * @memberof AppConfig
   */
  readonly timestamp = process.env.Timestamp;
  /**
   * Node env production
   * @memberof AppConfig
   */
  readonly production = lodash.eq(this.NODE_ENV, 'production');
  /**
   * Node env development
   * @memberof AppConfig
   */
  readonly development = lodash.eq(this.NODE_ENV, 'development');
  /**
   * Node env test
   * @memberof AppConfig
   */
  readonly test = lodash.eq(this.NODE_ENV, 'test');
  /**
   * 本地 dev
   * @memberof AppConfig
   */
  readonly develop = lodash.eq(this.APP_ENV, 'develop');
  /**
   * 生产环境
   * @memberof AppConfig
   */
  readonly release = lodash.eq(this.APP_ENV, 'release');
  /**
   * 预览环境
   * @memberof AppConfig
   */
  readonly trial = lodash.eq(this.APP_ENV, 'trial');
  /**
   * 测试环境
   * @memberof AppConfig
   */
  readonly sit = lodash.eq(this.APP_ENV, 'sit');
  /**
   * 测试环境 uat
   * @memberof AppConfig
   */
  readonly uat = lodash.eq(this.APP_ENV, 'uat');
  /**
   * 创建持久化 Key
   * @param {string} key
   */
  createStorageKey(key: string) {
    return BasesOptions.createStorageKey(key);
  }
}
export default new ClientsEnv();
